export const HTTP_GET_CALL_STARTED = 'HTTP_GET_CALL_STARTED';

export const BATCH_HTTP_GET_CALL_STARTED = 'BATCH_HTTP_GET_CALL_STARTED';

export const HTTP_GET_CALL_COMPLETED = 'HTTP_GET_CALL_COMPLETED';

export const BATCH_HTTP_GET_CALL_COMPLETED = 'BATCH_HTTP_GET_CALL_COMPLETED';

export const API_FETCH_REQUEST = 'API_FETCH_REQUEST';

export const API_FETCH_REQUEST_THROTTLED = 'API_FETCH_REQUEST_THROTTLED';

export const API_FETCH_SUCCESS = 'API_FETCH_SUCCESS';

export const API_FETCH_FAILED = 'API_FETCH_FAILED';

export const API_CLEAR = 'API_CLEAR';

export const PRISM_API_FETCH_SUCCESS = 'PRISM_API_FETCH_SUCCESS';

export const PRISM_API_PRE_LOGIN_SUCCESS = 'PRISM_API_PRE_LOGIN_SUCCESS';

export const PRISM_API_FETCH_FAILED = 'PRISM_API_FETCH_FAILED';

export const OAUTH_INITIATE = 'OAUTH_INITIATE';

export const OAUTH_TOKEN_SUCCESS = 'OAUTH_TOKEN_SUCCESS';

export const API_CLEAR_SUCCESS = 'API_CLEAR_SUCCESS';

export const SHOW_TOASTER = 'SHOW_TOASTER';

export const HIDE_TOASTER = 'HIDE_TOASTER';

export const HIDE_WELCOME_BANNER = 'HIDE_WELCOME_BANNER';

// Login Request
export const GET_LOGIN_REQUEST = 'GET_LOGIN_REQUEST';

export const LOGIN_REQUEST_UPDATE = 'LOGIN_REQUEST_UPDATE';

export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';

// V4 APIs
export const v4_API_FETCH_REQUEST = 'v4_API_FETCH_REQUEST';

export const V4_API_FETCH_REQUEST_THROTTLED = 'V4_API_FETCH_REQUEST_THROTTLED';

export const V4_API_FETCH_SUCCESS = 'V4_API_FETCH_SUCCESS';

export const V4_API_FETCH_FAILED = 'V4_API_FETCH_FAILED';

export const V4_API_GENERAL_FAILED = 'V4_API_GENERAL_FAILED';

export const V4_API_IGNORE_ERROR = 'V4_API_IGNORE_ERROR';
